import { User } from '@/models/user'
import { BaseAPI } from '@/api/base.api'
import { API_URL_AUTH, ID_APP, API_URL_SERVICE } from '@/commons/config'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

export class UserAPI extends BaseAPI<User> {
  constructor() {
    super()
    this.apiUrl = `${API_URL_SERVICE}/auth`
  }

  public signin (placa: string, renavam: string): AxiosObservable<User> {
    return this.axios.post(`${this.apiUrl}`, { placa, renavam, application: ID_APP })
  }
}
